import PropTypes      from 'prop-types'
import React          from 'react'
import { withRouter } from 'react-router'
import { NavItem    } from 'react-bootstrap'

import { NavLink        } from 'alto-react-components/lib/components'
import { UserBar        } from 'alto-react-base-auth/lib/components'
import { userBarSetting } from 'alto-react-client-auth/lib/settings'
import { ProfileNavLink } from 'alto-react-client-auth/lib/routes'

class ClientAuthUserBar extends UserBar.WrappedComponent
  @contextTypes = { auth: PropTypes.object, settings: PropTypes.object }

  navLinks: ->
    <React.Fragment>
      <ProfileNavLink />
      <NavItem id='logout-link' onClick={=> @logOut()}>Odhlásit</NavItem>
    </React.Fragment>

  userSignature: ->
    user    = @context.auth.loggedInUser
    client  = @context.auth.loggedInClient
    setting = userBarSetting(@context.settings)

    if user.isStaffOrAdmin
      user.username
    else
      switch setting.signature
        when 'fullname_and_client_id'
          "#{if user.fullName.length then user.fullName else user.username} (#{client.clientId})"
        else # 'username_and_fullname'
          super()

export default ClientAuthUserBar = withRouter(ClientAuthUserBar)
